import React from 'react'

const IconAppleWhite = ({style}) => {
    return (
        <svg style={style} width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M17.3768 12.617C17.3677 11.0323 18.075 9.83796 19.5033 8.9573C18.7044 7.79549 17.4959 7.15649 15.9027 7.03334C14.3943 6.91251 12.7439 7.92561 12.1396 7.92561C11.501 7.92561 10.0406 7.07516 8.89156 7.07516C6.52017 7.11234 4 8.99448 4 12.8238C4 13.9554 4.20372 15.1242 4.61116 16.3278C5.15594 17.9126 7.11989 21.7953 9.16853 21.7326C10.2398 21.707 10.9974 20.9612 12.3914 20.9612C13.7442 20.9612 14.4446 21.7326 15.6395 21.7326C17.7064 21.7024 19.4827 18.1728 20 16.5834C17.228 15.2567 17.3768 12.6983 17.3768 12.617ZM14.9711 5.52995C16.1316 4.13113 16.0263 2.85778 15.992 2.40002C14.9665 2.46044 13.7808 3.10873 13.1056 3.90573C12.3617 4.76083 11.9245 5.81808 12.0183 7.0101C13.1262 7.09608 14.1379 6.51749 14.9711 5.52995Z" fill="white" />
        </svg>
    )
}

export default IconAppleWhite
